/*! dependencies: cash */

instant.toggleHeight = {
  init: function () {

  },
  open: function (element) {
    if (!element.hasClass('js-active')) {
      element.addClass('js-active');
      element[0].style.height = 'auto';
      var height = element[0].clientHeight + 'px';
      element[0].style.height = '0px';
      setTimeout(() => { element[0].style.height = height; }, 0);
    }
  },
  close: function (element) {
    if (element.hasClass('js-active')) {
      element[0].style.height = '0px';
      element.removeClass('js-active');
    }
  },
  toggle: function (element) {
    if (element.hasClass('js-active')) {
      instant.toggleHeight.close(element);
    } else {
      instant.toggleHeight.open(element);
    }
  }
}